export default __webpack_public_path__ + "static/media/Vikings.4fc5a783.png";